<template>
  <v-app-bar app color="base_1">
    <v-row no-gutters align="center" class="toolbar-row">
      <v-col cols="3" class="d-flex align-center justify-start">
        <v-img
          :src="require('@/assets/bakerlogojust.png')"
          max-height="50"
          max-width="50"
          contain
        />
      </v-col>

      <v-col cols="6" class="d-flex align-center justify-center">
        <h2 class="primary--text toolbar-title">Familiestatuut</h2>
      </v-col>

      <v-col cols="3" class="d-flex align-center justify-end">
        <v-btn icon @click="toggle_dark_mode">
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
export default {
  name: "ToolBarAuth",
  data() {
    return {
      theme: null,
    };
  },
  methods: {
    toggle_dark_mode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
  },
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      this.$vuetify.theme.dark = theme === "true";
    }
  },
};
</script>

<style scoped>
.toolbar-row {
  width: 100%;
  height: 100%;
}

.toolbar-title {
  margin: 0;
  line-height: 1;
  white-space: nowrap;
}
</style>
